import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function ShieldHealthFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13.1662 1.53871C12.4391 1.15376 11.5609 1.15376 10.8338 1.53871C9.63189 2.17509 7.1696 3.32075 4.21644 3.8341C3.12696 4.02349 2.25 4.95478 2.25 6.12325V11.0511C2.25 14.5419 4.02964 17.2085 5.99214 19.0834C7.95205 20.9559 10.152 22.0975 11.1534 22.5619C11.6943 22.8127 12.3057 22.8127 12.8466 22.5619C13.848 22.0975 16.0479 20.9559 18.0079 19.0834C19.9704 17.2085 21.75 14.5419 21.75 11.0511V6.12325C21.75 4.95478 20.873 4.02349 19.7836 3.8341C16.8304 3.32075 14.3681 2.17509 13.1662 1.53871ZM11.002 8V11H8.00195V13H11.002V16H13.002V13H16.002V11H13.002V8H11.002Z"
				fill="currentColor"
			/>
		</svg>
	);
}

ShieldHealthFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default ShieldHealthFilledIcon;
